export default "__VITE_ASSET__5GVneb6J__"